import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../auth/authContext";
import useCatalogHome from "../../../catalog/hooks/useCatalogHome";
import { openCatalogLaunch } from "../../../catalog/utils/catalogLaunch";
import {
  ApplicationPage,
  ApplicationStateRegion,
  ApplicationViewHeader,
} from "../../../components/application";
import FacilitatedActivitySummaryCard from "../components/FacilitatedActivitySummaryCard";
import {
  listLiveModerationCatalogEntries,
  LIVE_MODERATION_LAUNCH_CONFIGURATION_ID,
} from "../utils/liveModerationCatalogEntries";

export default function FacilitateLiveChooserPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const {
    allEntries,
    loading,
    error,
  } = useCatalogHome();

  const eligibleEntries =
    listLiveModerationCatalogEntries(allEntries, {
      userRole: user?.role,
    });

  const handleStart = (entry) => {
    openCatalogLaunch(entry, navigate, {
      launchConfigurationId:
        LIVE_MODERATION_LAUNCH_CONFIGURATION_ID,
    });
  };

  return (
    <ApplicationPage
      className="av-facilitate-live-chooser-page"
      variant="workspace"
    >
      <ApplicationViewHeader
        backNavigation={
          <Link to="/app/facilitate">
            Back to Facilitate
          </Link>
        }
        contextLabel="Facilitated participation"
        title="Choose an activity for this live session"
      />

      {loading && (
        <ApplicationStateRegion
          status="loading"
          message="Loading live activities..."
        />
      )}

      {!loading && error && (
        <ApplicationStateRegion
          status="error"
          message="Live activities could not be loaded."
          detail={error}
        />
      )}

      {!loading && !error && eligibleEntries.length === 0 && (
        <ApplicationStateRegion
          status="empty"
          message="No live-session activities are available right now."
        />
      )}

      {!loading && !error && eligibleEntries.length > 0 && (
        <div className="av-facilitated-activity-grid">
          {eligibleEntries.map((entry) => (
            <FacilitatedActivitySummaryCard
              entry={entry}
              key={entry.slug}
              onStart={handleStart}
            />
          ))}
        </div>
      )}
    </ApplicationPage>
  );
}
